module.exports = __webpack_public_path__ + "static/img/egg_r_14.fd19615.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/r/egg_r_14.png
// module id = 8zlb
// module chunks = 1